declare namespace $ {

	type $mol_text__text_shm_projects_digest_day_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_button_minor__title_shm_projects_digest_day_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_projects_digest_day_3 = $mol_type_enforce<
		ReturnType< $shm_projects_digest_day['refresh'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_projects_digest_day_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_projects_digest_day_5 = $mol_type_enforce<
		ReturnType< $shm_projects_digest_day['text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	export class $shm_projects_digest_day extends $mol_view {
		Title( ): $mol_text
		refresh( next?: any ): any
		Refresh( ): $mol_button_minor
		Head( ): $mol_view
		text( ): string
		Text( ): $mol_text
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=day.view.tree.d.ts.map